import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassList = _resolveComponent("ClassList")!

  return (_openBlock(), _createBlock(_component_ClassList, {
    "is-admin": _ctx.isAdmin,
    "school-type": _ctx.schoolType,
    "change-school-type": _ctx.changeSchoolType,
    "school-year": _ctx.schoolYear,
    "change-school-year": _ctx.changeSchoolYear,
    data: _ctx.classes,
    "edit-state": _ctx.editState,
    "on-update-row": _ctx.onUpdateRow,
    "start-editing": _ctx.startEditing,
    "cancel-editing": _ctx.cancelEditing,
    save: _ctx.save
  }, null, 8, ["is-admin", "school-type", "change-school-type", "school-year", "change-school-year", "data", "edit-state", "on-update-row", "start-editing", "cancel-editing", "save"]))
}